import {TaxheadList} from "./TaxheadList";
import {TaxheadEdit} from "./TaxheadEdit";
import {TaxheadCreate} from "./TaxheadCreate";

export default {
    list: TaxheadList,
    create: TaxheadCreate,
    edit: TaxheadEdit
};
